import Lozenge from '@atlaskit/lozenge';
import { colors, elevation } from '@atlaskit/theme';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { redirect } from '../../../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../../../hoc/withAnalytics';
import { isNewTabClick } from '../../../util/event';
import { DEFAULT_ICON_PROPS } from '../ProductCard/ProductIcon';
import { cardContainerStyle, iconContainerStyle } from '../style';

export interface TryProduct {
  icon: typeof React.Component;
  name: string;
  url: string;
}

type Props = TryProduct & {
  fullScreen?: boolean;
};

const IconContainer = styled.div`
  ${iconContainerStyle};

  ${elevation.e200};
  transition: box-shadow 0.25s;
`;

const Container = styled.a`
  ${cardContainerStyle};

  &:hover {
    > ${IconContainer} {
      ${elevation.e400};
      color: ${colors.B300};
    }
  }
`;

const Description = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${colors.N800};
`;

class TryProductCard extends React.Component<Props & AnalyticsConsumerProps> {
  render() {
    const { icon, name, url } = this.props;
    const Icon = icon;
    return (
      <Container href={url} onClick={this.onClick}>
        <IconContainer>
          <Icon size="xlarge" {...DEFAULT_ICON_PROPS} />
        </IconContainer>
        <Description>{name}</Description>
        <Lozenge appearance="inprogress">
          <FormattedMessage {...messages.try} />
        </Lozenge>
      </Container>
    );
  }

  private onClick = async (event: React.MouseEvent<HTMLElement>) => {
    const { fullScreen, name, url } = this.props;
    const isOpeningInNewTab = isNewTabClick(event);
    if (!isOpeningInNewTab) {
      event.preventDefault();
    }
    await this.props.analytics.ui('tryProductCard', 'clicked', {
      fullScreen,
      name,
      url,
    });
    if (!isOpeningInNewTab) {
      redirect(url);
    }
  };
}

const messages = defineMessages({
  try: {
    defaultMessage: 'Try',
    description: 'Try this product',
    id: 'uchi.try',
  },
});

export default withAnalytics(TryProductCard);
